export const VIEW_LEARNING_PERMISSION_ID = 824;

export const canViewLearningCenter = ({ permissions = [] } = {}) => (
  Array.isArray(permissions) && permissions.map(Number).includes(VIEW_LEARNING_PERMISSION_ID)
);

export const storedLearningAccess = () => {
  let permissions = [];
  try { permissions = JSON.parse(localStorage.getItem('permissions') || '[]'); } catch (_) { permissions = []; }
  return canViewLearningCenter({ permissions });
};
